define('shared/initializer/form/adapters/mixins/fields/Location',[
    '../../../constants',
    'shared/util/state',
    'shared/util/hub',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/remote/country/get',
    'shared/remote/country/state/get',
    '$',
    'shared/util/fields/common',
    'shared/page/market',
    './util/updateTelephoneChuanr',
    './util/addDropdownDefaultOption'
],
function (
    constants,
    state,
    hub,
    RSVP,
    console,
    getCountry,
    getCountryState,
    $,
    fieldUtil,
    getMarket,
    updateTelephoneChuanr,
    addDropdownDefaultOption
) {
    'use strict';

    var MODULE_NAME = 'form/adapters/mixins/field/Location';
    var FIELD_COUNTRY = 'country';

    function updateChuanr(format) {
        return updateTelephoneChuanr(this, format);
    }

    function fillSelect(field, values, keyText, keyValue) {
        var $el = field.$el;

        return RSVP
            .resolve()
            .then(function () {
                var prmsText = [];
                var prmsValue = [];
                var prmsDisabled = [];
                var i;

                for (i = 0; i < values.length; i++) {
                    prmsText.push(values[i][keyText]());
                }

                for (i = 0; i < values.length; i++) {
                    prmsValue.push(values[i][keyValue]());
                }

                for (i = 0; i < values.length; i++) {
                    prmsDisabled.push(values[i].disabled != null ? values[i].disabled() : false);
                }

                return RSVP.all([RSVP.all(prmsText), RSVP.all(prmsValue), RSVP.all(prmsDisabled)]);
            })
            .then(function (results) {
                var texts = results[0];
                var values = results[1];
                var disabled = results[2];
                var count = 0;
                var $opt;

                $el.empty();

                addDropdownDefaultOption($el);

                for (var i = 0; i < texts.length; i++) {
                    if (disabled[i] === true) {
                        continue;
                    }
                    $opt = $(document.createElement('option'));
                    $opt
                        .attr('value', values[i])
                        .text(texts[i] || values[i])
                        .appendTo($el);

                    count++;
                }

                return RSVP.resolve(count);
            });
    }

    function mix(arr1, arr2) {
        var ret;
        var outer;
        var inner;
        var l;
        var k;

        arr1 = arr1 || [];
        arr2 = arr2 || [];

        if (arr2.length === 0) {
            return arr1;
        }
        if (arr1.length === 0) {
            return arr2;
        }

        ret = [];

        for (l = arr1.length; l--;) {
            outer = arr1[l];
            for (k = arr2.length; k--;) {
                inner = arr2[k];
                ret.push(outer + inner);
            }
        }

        return ret;
    }

    function getPhoneInfo(type, forceMarketCode) {
        var me = this;
        var fieldState = me.items[constants.FIELD.LOCATION_STATE];
        var fieldCity = me.items[constants.FIELD.LOCATION_CITY];
        var country;
        var state;
        var city;
        var stateCode = fieldState.$el.val();
        var cityCode = fieldCity.$el.val();
        var latestFormat;
        var marketCode = null;

        return RSVP.resolve()
            .then(function(){
                if(forceMarketCode){
                    marketCode = forceMarketCode;
                    return RSVP.resolve();
                }
                else{
                    return getMarket()
                        .then(function (pageMarketCode) {
                            marketCode = getMarketCodeOrDefault.call(me, pageMarketCode);
                        });
                }
            }).then(function () {
                return getCountry(marketCode);
            })
            .then(function (result) {
                country = result;
                var countryPhones = country.phones();
                return countryPhones[type] && countryPhones[type].prefix || [];
            })
            .then(function (phoneFormat) {
                latestFormat = phoneFormat;

                if(stateCode){
                    return getCountryState(marketCode, stateCode)
                        .then(function (result) {
                            state = result;
                            var statePhones = state.phones();
                            return mix(phoneFormat, statePhones[type] && statePhones[type].prefix || []);
                        });
                }
                else{
                    return phoneFormat;
                }

            })
            .then(function (phoneFormat) {
                latestFormat = phoneFormat;

                if(stateCode && state && cityCode){
                    var cities = state.cities();
                    for (var i = 0; i < cities.length; i++) {
                        var c = cities[i];
                        if (c.code() === cityCode) {
                            city = c;
                            break;
                        }
                    }
                }

                if (city && city.phones) {
                    var cityPhones = city.phones();
                    return mix(phoneFormat, cityPhones[type] && cityPhones[type].prefix || []);
                }
                else {
                    return phoneFormat;
                }
            })
            .then(null, function () {
                if (latestFormat != null) {
                    return RSVP.resolve(latestFormat);
                }
                else {
                    return RSVP.reject('Failed to retrieve format');
                }
            });
    }

    function updateChuanrByPhoneType(type, forceMarketCode) {
        var me = this;
        return getPhoneInfo.call(me, type, forceMarketCode)
            .then(function (phoneFormat) {
                updateChuanr.call(me, phoneFormat);
            }, function () {
                me.emit('error', 'Failed to retrieve phone info');
            });
    }

    function getMarketCodeOrDefault(defaultMarketCode) {
        var me = this;

        var countryField = me.items.get(FIELD_COUNTRY);
        if (countryField && countryField.$el.val()) {
            return countryField.$el.val();
        }
        else {
            return defaultMarketCode;
        }
    }

    function getFormMarketCode() {
        var me = this;

        return getMarket()
            .then(function(pageMarketCode) {
                return getMarketCodeOrDefault.call(me, pageMarketCode);
            });
    }

    function setCountryFieldDefaultValue() {
        var me = this;
        var fieldCountry = me.items.get(FIELD_COUNTRY);

        if (
            fieldCountry == null || 
            fieldCountry.$el == null
        ) {
            return RSVP.resolve();
        }

        return getFormMarketCode.call(me)
            .then(function(marketCode) {
                var $marketOption = fieldCountry.$el.find('option[value=' + marketCode + ']');
                var $firstOption = fieldCountry.$el.find('option').eq(0);
                if ($marketOption.length > 0) {
                    fieldCountry.$el.val(marketCode).change();
                }
                else {
                    fieldCountry.$el.val($firstOption.val()).change();
                }
            });
    }

    function fillStateSafe() {
        var args = arguments;
        var me = this;
        if (me.deferFillState) {
            return me.deferFillState.then(function(){
                return fillStateSafe.apply(me, args);
            });
        }
        else {
            me.deferFillState = new RSVP.Promise(function(rs){
                fillState.apply(me, args)
                    .then(rs);
            });
            return me.deferFillState.then(function(){
                me.deferFillState = null;
            });
        }
    }

    function disableField(field, hide) {
        field.$el.attr('disabled', 'disabled');

        if (hide === true) {
            field.$wrap.stop().slideUp();
        }
    }

    function enableField(field, show) {
        field.$el.removeAttr('disabled');

        if (show === true) {
            field.$wrap.stop().slideDown();
        }
    }

    function fillState(marketCode) {
        var me = this;
        var fieldState = me.items.get(constants.FIELD.LOCATION_STATE);
        var fieldCity = me.items.get(constants.FIELD.LOCATION_CITY);
        var fieldPhone = me.items.get(constants.FIELD.PHONE);
        var fieldPhoneType = me.items.get(constants.FIELD.PHONE_TYPE);
        var states = [];

        if (fieldState == null || !marketCode) {
            return RSVP.resolve();
        }

        me.block();

        return RSVP.resolve()
            .then(function(){
                disableField.call(me, fieldState, true);
                disableField.call(me, fieldCity, true);

                return getCountry(marketCode);
            })
            .then(function (country) {
                if (country == null) {
                    throw new Error('No such country: ' + marketCode);
                }

                states = country.states();
                return fillSelect(fieldState, states, 'name', 'code')
                    .then(function(){
                        fieldState.$el.change();
                    });
            })
            .then(function(){
                if(!states || states.length === 0){
                    if (fieldPhone) {
                        enableField.call(me, fieldPhone);
                        updateChuanrByPhoneType.call(me, fieldPhoneType.$el.val(), marketCode);
                    }
                }
                else{
                    enableField.call(me, fieldState, true);
                }

                return RSVP.resolve();
            })
            .then(function () {
                var preSelectedState = null;
                switch (marketCode) {
                    case 'ar':
                        preSelectedState = 'capital-federal';
                        break;
                    case 'bo':
                        preSelectedState = 'santa-cruz';
                        break;
                    case 'cl':
                        preSelectedState = 'santiago-metropolitan';
                        break;
                    case 'co':
                        preSelectedState = 'bogota';
                        break;
                    case 'ec':
                        preSelectedState = 'guayas';
                        break;
                    default:
                        break;
                }

                if (preSelectedState) {
                    fieldState
                        .$el
                        .val(preSelectedState)
                        .change();
                    handleStateChanged.call(me, marketCode, preSelectedState);
                }

                return RSVP.resolve();
            })
            .then(function() {
                me.resume();
            });
    }

    function handleStateChanged(marketCode, stateCode) {
        var me = this;
        var fieldCountry = me.items.get(FIELD_COUNTRY);
        var fieldCity = me.items[constants.FIELD.LOCATION_CITY];
        var fieldPhoneType = me.items[constants.FIELD.PHONE_TYPE];
        var fieldPhone = me.items[constants.FIELD.PHONE];

        if (fieldCity == null || !marketCode) {
            return RSVP.resolve();
        }

        if (!stateCode) {
            fieldCity.$el.empty();
            fieldCity.$wrap.hide();
            return RSVP.resolve();
        }

        if(fieldCountry && fieldCountry.$el.val() !== marketCode){
            console.log(
                MODULE_NAME, 
                'Country has been changed during asynchronous data fetch, aborting...'
            );
            return RSVP.resolve();
        }

        me.block();

        return getCountryState(marketCode, stateCode)
            .then(function (state) {
                var cities = state.cities();
                if (cities && cities.length > 0) {
                    enableField.call(me, fieldCity, true);
                    if (fieldPhone) {
                        disableField.call(me, fieldPhone);
                    }

                    return fillSelect(fieldCity, cities, 'name', 'code')
                        .then(function(){
                            if(cities.length == 1){
                                var singleCity = cities[0];
                                fieldCity.$el.val(singleCity.code());
                                fieldCity.$wrap.hide();
                            }
                            fieldCity.$el.change();

                            return RSVP.resolve();
                        });
                }
                else {
                    disableField.call(me, fieldCity, true);
                    if (fieldPhone) {
                        enableField.call(me, fieldPhone);
                        updateChuanrByPhoneType.call(me, fieldPhoneType.$el.val(), marketCode);
                    }
                }

                return RSVP.resolve();
            })
            .then(function(){
                me.resume();
            });
    }

    function initCountry() {
        var me = this;
        var fieldCountry = me.items.get(FIELD_COUNTRY);

        if (!fieldCountry) {
            return getMarket()
                .then(function (marketCode) {
                    return fillStateSafe.call(me, marketCode);
                });
        }

        addDropdownDefaultOption(fieldCountry.$el, true);

        fieldCountry.$el.on('change', function () {
            var selectedMarketCode = fieldCountry.$el.val();
            return fillStateSafe.call(me, selectedMarketCode);
        });

        return setCountryFieldDefaultValue.call(me);
    }

    function initState() {
        var me = this;
        var fieldState = me.items[constants.FIELD.LOCATION_STATE];

        if (!fieldState) {
            return RSVP.resolve();
        }

        fieldState.$el.on('change', function () {
            getFormMarketCode.call(me)
                .then(function (formMarketCode) {
                    handleStateChanged.call(me, formMarketCode, fieldState.$el.val()); 
                });
        });
    }

    function initCity() {
        var me = this;
        var fieldCity = me.items.get(constants.FIELD.LOCATION_CITY);
        var fieldPhone = me.items.get(constants.FIELD.PHONE);
        var fieldPhoneType = me.items.get(constants.FIELD.PHONE_TYPE);

        if (!fieldCity) {
            return RSVP.resolve();
        }

        fieldCity.$el.on('change', function () {
            var value = fieldCity.$el.val();

            if (fieldPhone) {
                if (value) {
                    enableField.call(me, fieldPhone);
                    updateChuanrByPhoneType.call(me, fieldPhoneType.$el.val());
                }
                else {
                    disableField.call(me, fieldPhone);
                }
            }
        });
    }

    function initPhone() {
        var me = this;
        var fieldCountry = me.items.get(FIELD_COUNTRY);
        var fieldPhone = me.items.get(constants.FIELD.PHONE);
        var fieldPhoneType = me.items.get(constants.FIELD.PHONE_TYPE);

        if (fieldPhone) {
            disableField.call(me, fieldPhone);
        }

        if (fieldPhoneType) {
            fieldPhoneType.$wrap.show();
            fieldPhoneType.$el.on('change', function () {
                if(fieldCountry){
                    var selectedCountryCode = fieldCountry.$el.val();
                    if(selectedCountryCode){
                        updateChuanrByPhoneType.call(me, fieldPhoneType.$el.val(), selectedCountryCode);
                    }
                }else{
                    updateChuanrByPhoneType.call(me, fieldPhoneType.$el.val());
                }
            });
        }
    }

    function Ctor() {
    }

    Ctor.prototype.doPageLoad = function doPageLoad() {
        var me = this;
        var fieldState = me.items.get(constants.FIELD.LOCATION_STATE);

        if (fieldState == null) {
            return RSVP.resolve();
        }

        return RSVP.resolve()
            .then(function () {
                return initPhone.call(me);
            })
            .then(function() {
                return initCity.call(me);
            })
            .then(function() {
                return initState.call(me);
            })
            .then(function() {
                return initCountry.call(me);
            });
    };

    Ctor.prototype.doBeforeSubmit = function() {
        var me = this;
        var copyField = function(source, target) {
            return fieldUtil.copyField.call(this, source, target, me.$form);
        };

        copyField(constants.FIELD.LOCATION_STATE, constants.FIELD.STATE);
        copyField(constants.FIELD.LOCATION_STATE, constants.FIELD.StateCode);
        copyField(constants.FIELD.LOCATION_STATE, constants.FIELD.MemberStateCode);
        copyField(constants.FIELD.LOCATION_CITY, constants.FIELD.CITY);
        copyField(constants.FIELD.LOCATION_CITY, constants.FIELD.CityCode);
        copyField(constants.FIELD.LOCATION_CITY, constants.FIELD.MemberCityCode);
        copyField(constants.FIELD.PHONE_TYPE, 'telephonetype');

        return RSVP.resolve();
    };

    return Ctor;
});

